import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useLocaleContext } from '@/website/contexts/AppContext';
import { LanguageEnum } from '@/website/contexts/AppContext';
import { useJumpLink } from '@/website/hooks/useJumpLink';
import { useOrganizationLandingPageStore } from '@/website/store/OrganizationLandingPageStore';
import { getLanguageCookie } from '@/website/util/cookies';
import clsx from 'clsx';
import qs from 'qs';

export default function ValidationButton({ className }: { className?: string }) {
  const router = useRouter();
  const { country, language } = useLocaleContext();
  const { getJumpCountryCode } = useJumpLink();
  const [jumpUrl, setJumpUrl] = useState('');
  const currentLanguage = getLanguageCookie();
  const renderText = new Map([
    [LanguageEnum.EN, 'Validate insurance'],
    [LanguageEnum.FR, 'Valider l’assurance'],
    [LanguageEnum.ES, 'Validar el seguro'],
    [LanguageEnum.PT, 'Validar o seguro'],
    [LanguageEnum.DE, 'Versicherung validieren'],
    [LanguageEnum.NL_BE, 'Verzekering valideren'],
    [LanguageEnum.NL_NL, 'Verzekering verifiëren'],
  ]);
  const {
    state: { organization },
  } = useOrganizationLandingPageStore();

  /**
   * effects
   */
  useEffect(() => {
    const params = {
      organization_id: organization?.id,
      forceCountryCode: getJumpCountryCode({ country, language }),
    };
    setJumpUrl(`${process.env.NX_VALIDATION_URL}?${qs.stringify(params)}`);
  }, [country, language]);

  if (!organization?.id) return null;

  return (
    <Link
      href={jumpUrl}
      target="_blank"
      className={clsx(
        'border-brand-secondary text-brand-secondary hover:bg-brand-secondary text-md flex w-fit items-center justify-center rounded-full border-2 px-4 py-2 font-bold hover:text-white',
        className
      )}
    >
      {renderText.get(currentLanguage as any) || renderText.get(LanguageEnum.EN)}
    </Link>
  );
}
